import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/ui/screens/about/AboutWrapper.tsx");
